'use strict';

module.exports = {
    LOCATION_SEARCHED: 'Location_Searched',
    ORDER_HERE: 'Order_Here_Clicked',
    NAV_ORDER_CLICKED: 'Nav_Order_Clicked',
    NAV_FIND_CLCIKED: 'Nav_Location_Clicked',
    NAV_MY_CLICKED: 'Nav_My_Clicked',
    NAV_MENU_CLICKED: 'Nav_Menu_Clicked',
    LOG_IN_SUMMARY: 'Log_In_Summary',
    CREATE_ACCOUNT: 'Create_Account',
    LOG_IN_TYPE_CLICKED: 'Log_In_Type_Clicked',
    ACCOUNT_CREATION_CANCEL: 'Account_Creation_Cancel',
    PAGEVIEW: 'pageview',
    PURCHASE_PRODUCT_ACTION: 'purchase',
    PURCHASE_EVENT_ACTION: 'Purchase',
    EVENT: 'event',
    ENHANCED_ECOMMERCE: 'Enhanced Ecommerce'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/Constants.js
// module id = 211
// module chunks = 0